import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnalyticsService } from 'src/app/_services/analytics.service';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import { WebsiteService } from 'src/app/_services/website.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pricing-home',
  templateUrl: './pricing-home.component.html',
  styleUrls: ['./pricing-home.component.scss']
})
export class PricingHomeComponent implements OnInit {

  isYearlyChecked: boolean = true;
    formSection: boolean = true;
    thankSection: boolean = false;
    disabledSubmitButton: boolean = true;
    contactUsSection: String;
    monthfinalSection: boolean = false;
    YearlyfinalSection: boolean = true;
    country: string;
    encodedData: any;
    decodedData: any;
    paymentModeOption: any;
    finalAmmount: any;
    isSticky = false;
    isSubmitting: boolean = false;
    activeTab: string = 'individuals';
    Math = Math; 
    trinkaCloudUrl = environment.trinkaCloudUrl;
    countryLoaded = false;
    countryCode = '';
    showDiscount = false;
    constructor(
      private route: ActivatedRoute,
      public loadScript: LoadScriptService,
      public paymentService: WebsiteService,
      @Inject(PLATFORM_ID) private platformId: Object,
      private analyticsService: AnalyticsService
    ) {
      
      
    }
  
    ngOnInit() {
      if (isPlatformBrowser(this.platformId)) {
  
        const savedCountry = localStorage.getItem('country-trinka');
      
        if (savedCountry) {
      
          this.countryCode = savedCountry;
          this.countryLoaded = true;
          this.fetchPlans();
          this.updatePricingState();
        } else {
      
          this.loadGeoAPIScript();
      
        }
      
      }
      
      //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
    }
  
    get isIndonesia(): boolean {
      return this.countryCode === 'ID';
    }
  
    updatePricingState() {
      this.showDiscount = 
        this.countryLoaded &&
        this.isYearlyChecked &&
        this.countryCode !== 'ID';
    }
  
    loadGeoAPIScript() {
      if (isPlatformBrowser(this.platformId)) {
    
        const scriptName = "geoIP";
    
        this.loadScript.loadScript(
          scriptName,
          '//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js'
        )
        .then(() => {
    
          console.log(`${scriptName} loaded successfully`);
    
          const onSuccess = (location) => {
    
            this.countryCode = location.country.iso_code;
    
            localStorage.setItem(
              "country-trinka",
              this.countryCode
            );
    
            this.countryLoaded = true;
            this.updatePricingState();
    
            this.fetchPlans();
          };
    
    
          const onError = (error) => {
    
            console.error('GeoIP error:', error);
    
            this.countryCode = "IN";
    
            localStorage.setItem(
              "country-trinka",
              this.countryCode
            );
    
            this.countryLoaded = true;
            this.updatePricingState();
    
            this.fetchPlans();
          };
    
    
          try {
            // @ts-ignore
            geoip2.city(onSuccess, onError);
    
          } catch (error) {
            console.error('GeoIP catch error:', error);
          }
    
        })
        .catch(() => {
          console.error(`Failed to load ${scriptName}`);
        });
      }
    }
    
  
    fetchPlans() {
      this.country = this.countryCode;
      this.route.params.subscribe(params => {
        this.encodedData = params['id'];
        this.paymentService.getPlans(this.encodedData, 1).subscribe(resp => {
          if (resp['message'] === 'success') {
            this.decodedData = resp['data'];
            this.decodedData.sort((a, b) => a.index - b.index);
            this.paymentModeOption = this.decodedData;
            console.log("Country is: ", this.country);
            const annualAmount = this.decodedData[3].final_amount;
            this.finalAmmount = annualAmount / 12;
          }
        });
      });
    }
    
    
    monthyPricing() {
      this.monthfinalSection = true;
      this.YearlyfinalSection = false;
    }
    yearlyPricing() {
      this.monthfinalSection = false;
      this.YearlyfinalSection = true;
    }
    //   scroll(el: HTMLElement) {
    //     el.scrollIntoView();
    // }
    scroll(el: HTMLElement) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
    ngOnDestroy() {
      
    }
  
    buildPlanCheckoutUrl(
      planType: string,
      opts: { isAnnual?: boolean; coupon?: string } = {}
    ) {
      const {
        isAnnual = this.isYearlyChecked,
        coupon
      } = opts;
    
      const payload = {
        frmktg: true,
        go_to_payments: true,
        plan_type: planType,
        planType: planType,
        isAnnualPlan: isAnnual ? 1 : 0,
        plan_name: 'basic'
      };
    
      const encoded = btoa(encodeURIComponent(JSON.stringify(payload))).replace(/=/g, '');
    
      const couponSuffix = coupon
        ? `?cp=${encodeURIComponent(coupon)}`
        : '';
    
      return `${environment.paymentsUrl}/user/${encoded}${couponSuffix}`;
    }
  
    trackPricingClick(planName: string) {
      this.analyticsService.trackEvent(
        'pricing_button_click',
        { 
          plan_name: planName, 
          page: 'homepage'
        }
      );
    }
  
  
    calculateIntegerPart(amount: number): number {
      return Math.floor(amount);
    }
    
    calculateFractionalPart(amount: number): string {
      const fractional = amount - Math.floor(amount);
      return fractional.toFixed(2).substring(1);
    }
  
    getOriginalPrice(finalAmount: number): number {
      if (!finalAmount) return 0;
    
      return finalAmount / 0.3333;
    }
  
  

}
